import {DataSource} from '@angular/cdk/table';
import {CollectionViewer} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {TestResultService} from '../../services/api/result/test-result.service';
import {TestResult} from '../models/result/test-result';
import {TestResultFilters} from '../models/filters/test-result-filters';

export class TestResultsDataSource implements DataSource<TestResult> {

  private testResultsSubject = new BehaviorSubject<TestResult[]>([]);
  private totalElementsSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public totalElements$ = this.totalElementsSubject.asObservable();
  public loading$ = this.loadingSubject.asObservable();

  constructor(
    private testResultService: TestResultService,
  ) {
  }

  connect(collectionViewer: CollectionViewer): Observable<TestResult[] | ReadonlyArray<TestResult>> {
    return this.testResultsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.testResultsSubject.complete();
    this.totalElementsSubject.complete();
    this.loadingSubject.complete();
  }

  loadTestResults(
    filters: TestResultFilters,
    sort: any[], pageSize: number, pageNumber: number,
  ): void {

    this.loadingSubject.next(true);

    this.testResultService.searchTestResults(filters, sort, pageSize, pageNumber)
      .then(page => {
        this.testResultsSubject.next(page.content);
        this.totalElementsSubject.next(page.totalElements);
      })
      .catch(error => {
        this.testResultsSubject.next([]);
        this.totalElementsSubject.next(0);
      })
      .finally(() => {
        this.loadingSubject.next(false);
      });
  }

}
